import {track, extractWebAttributionProperties} from '@malt/tracking';

Hop.defineModule('track-website-page-view', (root, params) => {
    function getSourceComponent() {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get('source_component') || null;
    }

    function trackWebsitePageView() {
        const eventProperties = {
            url: window.location.pathname,
            page_title: document.title,
            page_category: params.pageCategory,
            page_subcategory: params.pageSubCategory,
        };
        const userProperties = {
            ...extractWebAttributionProperties(),
            referrer: document.referrer || null,
            source_component: getSourceComponent(),
        };
        track('website_page_viewed', eventProperties, userProperties);
    }
    window.onload = trackWebsitePageView;
});
